import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { withValueArray } from 'Helpers/MetaOverride';
import { FDBodyText, FDHeadlineText, FDTitleText } from '@facet-wealth/design';
import BodyList from 'Components/ComponentLibrary/Molecules/BodyList';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: { color: 'textSecondary' },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => withValueArray(FDBodyText),
  }, overrideReadOnly)
  .nameOverride('bodyTitle', {
    _component: () => FDTitleText,
    _customProps: { color: 'textSecondary' },
  }, overrideReadOnly)
  .nameOverride('body', {
    _component: () => BodyList,
  }, overrideReadOnly);

export default metaOverrideSet;
